import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { PoEmailQuoteService } from "../../../../core/services/po-email-quote.service";
import { DisplayPdfFrameQuoteService } from "../../../../core/services/display-pdf-frame-quote.service";
import { EmailTemplates } from "../../../../core/models/orders/emailTemplates";
import { LoaderService } from "../../../../core/services/loader.service";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-display-pdf-frame-quote",
  templateUrl: "./display-pdf-frame-quote.component.html",
  styleUrls: ["./display-pdf-frame-quote.component.scss"],
  imports: [
    CheckboxModule,
    ReactiveFormsModule,
    NgxExtendedPdfViewerModule,
    SelectModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class DisplayPdfFrameQuoteComponent implements OnInit {
  @Input() parent!: FormGroup;
  @Input() set templatesList(emailTemplates: EmailTemplates[]) {
    this.templates = emailTemplates;
    this.parent.patchValue({
      header: {
        templateId: this.templates[0]?.id,
      },
    });
  }
  @Input() quoteId = "";
  @Input() poNumberRevision: string[] = [];
  @Output() emailSelectionEvent = new EventEmitter();
  @Output() templateSelectedEvent = new EventEmitter();

  templates: EmailTemplates[] = [];
  proposalJournalPdf = "";

  constructor(
    private _displayPdfFrameService: DisplayPdfFrameQuoteService,
    private _activatedRoute: ActivatedRoute,
    private _poEmailQuoteService: PoEmailQuoteService,
    private _loaderService: LoaderService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.quoteId = params["id"];
    });
  }

  ngOnInit(): void {
    this.getQuotesEmail();
  }

  getQuotesEmail() {
    this._poEmailQuoteService.ProposalSummaryDocument(this.quoteId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.status.toLowerCase() == "success") {
          this.proposalJournalPdf = res.data;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  onTemplateSelection() {
    this.templateSelectedEvent.emit(
      this.parent.get(["header", "templateId"])?.value ?? 0
    );
  }

  onRevisedSelection(event: CheckboxChangeEvent) {
    this._displayPdfFrameService.onRevisedSelection(event);
  }

  onEmailSelection() {
    this.emailSelectionEvent.emit();
  }
}
